export default __webpack_public_path__ + "static/account-dashboard-7f465fed4ea41915183c9143ef0ff884.png";